(function(angular, schoolwork12) {
	'use strict';
	
	schoolwork12.app.graduationPlan = {
        name: 'schoolwork12.graduationPlan',
        controllers: {
            manageGraduationPlan : 'graduationPlanCtrl',
            addSchoolPlan : 'addSchoolPlanCtrl',
            editSchoolPlan : 'editSchoolPlanCtrl',
            subjectCriteria: 'subjectCriteriaCtrl'
        },
        routes: {
            manageGraduationPlan: '/manage-school-graduation-plans',
            addSchoolPlan: '/add-school-graduation-plan',
            editSchoolPlan: '/edit-school-graduation-plan'
        },
        templates : {
            manageGraduationPlan: 'graduationPlan/html/manageGraduationPlan.html',
            addSchoolPlan : 'graduationPlan/html/addSchoolPlan.html',
            editSchoolPlan : 'graduationPlan/html/editSchoolPlan.html',
            subjectCriteriaModal: 'graduationPlan/html/subjectCriteriaModal.html'

        },
        services: {
            graduationPlanSvc: 'graduationPlanSvc'        
        },
        endpoints: {
            getSchoolDiplomaEndpoint: schoolwork12.app.endpoint.concat('/diploma/school/'),
            getSchoolSubjectsEndpoint: schoolwork12.app.endpoint.concat('/subjects/school/'),
            saveSchoolDiplomaEndpoint: schoolwork12.app.endpoint.concat('/diploma/school/'),
            getDiplomaById: schoolwork12.app.endpoint.concat('/diploma/'),
            getSchoolTerms: schoolwork12.app.endpoint.concat('/schools/terms'),
            editSchoolDiplomaEndpoint: schoolwork12.app.endpoint.concat('/diploma/'),
            getGraduationPlanEndpoint: schoolwork12.app.endpoint.concat('/gradPlan/diploma/'),
            editGradPlanEndpoint: schoolwork12.app.endpoint.concat('/gradPlan/'),
            getCategoriesEndpoint: schoolwork12.app.endpoint.concat('/gradplan/addreq/categories'),
            saveGradPlanNotesEndpoint: schoolwork12.app.endpoint.concat('/student/notes/gradplan/'),
            getAuditTrailGradPlanNotesEndpoint: schoolwork12.app.endpoint.concat('/student/notes/gradplan/audit/'),
            getLearningCoachEndpoint: schoolwork12.app.endpoint.concat('/student/learningCoach/'),
        }
	};
	
    angular.module(schoolwork12.app.graduationPlan.name, ['ui.grid', 'ui.grid.resizeColumns', 'ui.grid.pagination','ngTagsInput']);
	 
}(angular, schoolwork12));
